class ProductInfiniteScroll extends HTMLElement {
  constructor() {
    super();
    //this.init();
  }

   connectedCallback() {
    this.reInit();
    }

  reInit() {
    // this.wrapper = this.querySelector('.product-list-wrapper');
    this.wrapper = this;  // Use 'this' since the class is on the custom element itself

    this.loadMoreButton = document.getElementById('load-more-products');
    this.currentPage = parseInt(this.wrapper.dataset.infiniteCurrent, 10);
    this.maxArticlesPerPage = parseInt(this.wrapper.dataset.infiniteMax, 10);
    this.totalPages = parseInt(this.wrapper.dataset.infinitePages, 10);
    this.nextUrl = this.wrapper.dataset.infiniteNext;

    this.updateProductCount();

    const urlHash = window.location.hash.replace('#', '');
    if (urlHash && !isNaN(urlHash) && parseInt(urlHash, 10) > 1) {
      const targetPage = parseInt(urlHash, 10);
      this.loadProductsUpToPage(targetPage);
    }

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', this.loadMoreProducts.bind(this));
    }
  }

  async loadProductsUpToPage(targetPage) {
    while (this.currentPage < targetPage && this.currentPage < this.totalPages) {
      await this.loadMoreProducts(false);
    }
  }

  async loadMoreProducts(updateHash = true) {
      console.log('click');
    if (this.currentPage >= this.totalPages) {
      this.loadMoreButton.style.display = 'none';
      return;
    }

    this.currentPage++;
    this.loadMoreButton.setAttribute('aria-disabled', 'true');
    this.loadMoreButton.classList.add('is-loading');

    try {
      const response = await fetch(this.nextUrl.replace('[% page %]', this.currentPage));
      const htmlText = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const newProducts = doc.querySelectorAll('product-card');

      newProducts.forEach((article) => {
        this.wrapper.appendChild(article);
      });

      const newWrapper = doc.querySelector('.product-list');
      this.nextUrl = newWrapper.dataset.infiniteNext;

      if (updateHash) {
        window.location.hash = this.currentPage;
      }

      if (this.currentPage >= this.totalPages) {
        this.loadMoreButton.style.display = 'none';
      }

      this.updateProductCount();
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.loadMoreButton.removeAttribute('aria-disabled');
      this.loadMoreButton.classList.remove('is-loading');
    }
  }

  updateProductCount() {
    const productsVisible = this.wrapper.querySelectorAll('product-card').length;
    const productCountElement = document.querySelector('.product__infinite--products-viewing');
    productCountElement.textContent = `${productsVisible}`;

    if (this.totalPages === 1) {
      this.loadMoreButton.style.display = 'none';
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.loadMoreButton.getAttribute('aria-disabled')) {
        this.loadMoreProducts();
      }
    });
  }
}

// customElements.define('product-infinite-scroll', ProductInfiniteScroll);
customElements.define('product-list', ProductInfiniteScroll);


function initProductInfiniteScroll() {
  const productListEls = document.querySelectorAll('product-list');
  // console.log('test test test 1');

  productListEls.forEach((el) => {
    console.log('test test test 2');
    if (typeof el.reInit === 'function') {
      el.reInit();
      console.log('test test test 3');
    } else {
      console.warn('reInit is geen functie op', el);
    }
  });
}


document.addEventListener('facet:updated', () => {
  console.log('facet:updated ontvangen in infinite-scroll.js');

  // Herinitialiseer Infinite Scroll functionaliteit
  initProductInfiniteScroll();
});
